export const partners = [1873002, 1726359, 1053119, 2450849, 2013404, 782216, 1783625, 2529621];